import React, { useEffect } from "react";
import { styled } from "../stitches.config";

export default function DefaultCursor({
  color = "#040404",
}: {
  color: string;
}) {
  useEffect(() => {
    document.body.style.cursor = "none";
    return () => {
      document.body.style.cursor = "auto";
    };
  }, []);

  const path =
    "M2.5,5.1C2,3.5,3.5,2,5.1,2.5l10.5,3.5c1.7,0.6,1.8,2.9,0.3,3.7l-3.1,1.6c-0.6,0.3-1.1,0.8-1.3,1.3l-1.6,3.1c-0.8,1.6-3.1,1.4-3.7-0.3L2.5,5.1z";
  return (
    <SvgContainer>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        overflow="visible"
      >
        <defs>
          <filter id="shadow" height="300%" y="-100%" width="300%" x="-100%">
            <feDropShadow
              dx="0"
              dy="1"
              stdDeviation="2"
              floodColor="black"
              floodOpacity=".50"
            />
          </filter>
        </defs>
        <path
          d={path}
          fill={color}
          style={{
            filter: "url(#shadow)",
          }}
        />
        <WhiteOutline d={path} strokeWidth="4" />
        <path d={path} fill={color} />
        <BrownInstroke d={path} strokeWidth="1" />
      </svg>
    </SvgContainer>
  );
}

const SvgContainer = styled("div", {
  position: "absolute",
  top: 0,
  left: 0,
  pointerEvents: "none",
});

const WhiteOutline = styled("path", {
  stroke: "$transparentWhite",
});

const BrownInstroke = styled("path", {
  stroke: "$brown",
});
